import type { AxiosResponse } from 'axios';

import { DisplayMode } from '../constants/display-mode';

type TenantUrlOptions = {
  tenant: string;
  routeName?: string;
  chargePointId?: string | number;
  evseId?: string;
  extraPath?: string;
  pathPrefix?: string;
};

export function buildTenantUrl({
  pathPrefix = '',
  tenant,
  routeName,
  chargePointId,
  evseId,
  extraPath = '',
}: TenantUrlOptions): string {
  let url = `/tenant/${tenant}`;
  const prefix = `${pathPrefix}`;
  if (pathPrefix) url = prefix + url;
  if (chargePointId) url += `/cp/${chargePointId}`;
  if (evseId) url += `/evse/${evseId}`;

  if (routeName) url += `/${routeName}`;
  if (extraPath) url += `/${extraPath}`;

  return url;
}

export function checkPathnameIncludes(segment: string): boolean {
  return window.location.pathname.includes(segment);
}

// Helper to extract the URL prefix before '/tenant'
// e.g., from '/apps/supercharge/some/2/tenant/...' returns '/apps/supercharge/some/2'
export function getCurrentUrlPrefix(): string {
  const pathname = window.location.pathname;
  const tenantIndex = pathname.indexOf('/tenant');

  if (tenantIndex === -1) {
    return '';
  }

  return pathname.substring(0, tenantIndex);
}

// Helper to handle navigation after next
export function handleSearchNavigation({
  response,
  displayMode,
  navigate,
  evsePhysicalReference,
  ROUTE_NAMES,
}: {
  response: AxiosResponse<any, any>;
  displayMode: DisplayMode;
  navigate: (url: string) => void;
  evsePhysicalReference: string;
  ROUTE_NAMES: Record<string, string>;
}) {
  if (displayMode === DisplayMode.ChargePoint) {
    navigate(
      buildTenantUrl({
        pathPrefix: '..',
        tenant: response.headers['tenant'],
        routeName: ROUTE_NAMES.chargePoint,
      })
    );
  } else {
    navigate(
      buildTenantUrl({
        pathPrefix: '..',
        tenant: response.headers['tenant'],
        chargePointId: response?.data?.data?.chargePointId,
        evseId: evsePhysicalReference,
        routeName: ROUTE_NAMES.selectEvse,
      })
    );
  }
}
